import { ArrowRight } from 'lucide-react';

import { cn } from '~/utils/cn';

/**
 * 20×20 muted box with a right arrow — the shared "before → after" divider
 * used between two values (a delta pair, a before/after readout). When
 * `muted`, the icon dims further to match a locked-column or unavailable state.
 */
export function ArrowBox({ muted = false }: { muted?: boolean }) {
  return (
    <div className="bg-muted flex h-5 w-5 shrink-0 items-center justify-center rounded-[5px] p-[5px]">
      <ArrowRight
        className={cn('h-full w-full', muted ? 'text-muted-foreground' : 'text-foreground')}
      />
    </div>
  );
}
